const en = {
  "vps.databases": "Bases de Datos",
  "vps.databases.vps": "Servidor",
  "vps.databases.state": "Estado",
  "vps.databases.customer": "Cliente",
  "vps.databases.name": "Nombre Base de Datos",
  "vps.databases.enable": "Habilitada",
  "vps.databases.disable": "Deshabilitada",
};
export default en;
